
export const PATH = `${process.env.REACT_APP_API_URL}/api/`;
export const PATH_STORAGE = `${process.env.REACT_APP_DO_SPACES_URL}/`;
export const PROXY = 'https://cors-anywhere.herokuapp.com/';
